import $ from 'jquery'

import { registerComponent } from '../app'
import { WINDOW_RESIZE, OPEN_MENU, CLOSE_MENU, OPEN_CART, CLOSE_CART } from '../events'

const Header = (scope, el) => {
	const props = {
		fixedClass: 'fixed',
		visibleClass: 'visible',
		menuOpenClass: 'menu-open',
		cartOpenClass: 'cart-open'
	}

	const state = {
		offset: 0,
		height: 0,
		lastScroll: 0
	}

	const els = {
		$wrap: $(el.querySelector('[data-wrap]'))
	}

	function refreshOffset() {
		state.offset = $(el).offset().top
		state.height = $(el).height()
	}

	function refreshVisibility() {
		const position =
			window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

		if (position > state.offset + state.height) {
			el.classList.add(props.fixedClass)
		} else if (position <= state.offset + state.height) {
			el.classList.remove(props.fixedClass)
		}

		if (position < state.lastScroll) {
			el.classList.add(props.visibleClass)
		} else {
			el.classList.remove(props.visibleClass)
		}

		state.lastScroll = position
	}

	// events

	function onScroll() {
		refreshVisibility()
	}

	scope.on(WINDOW_RESIZE, () => {
		refreshOffset()
	})

	scope.on(OPEN_MENU, () => {
		el.classList.add(props.menuOpenClass)
	})

	scope.on(CLOSE_MENU, () => {
		el.classList.remove(props.menuOpenClass)
	})

	scope.on(OPEN_CART, () => {
		el.classList.add(props.cartOpenClass)
	})

	scope.on(CLOSE_CART, () => {
		el.classList.remove(props.cartOpenClass)
	})

	window.addEventListener(
		'scroll',
		() => {
			onScroll()
		},
		{ passive: true }
	)

	refreshOffset()
}

registerComponent('header', Header)
